import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { formatString } from '@frontend/sports/common/core/utils/string';
import { ThemeOptions } from '@frontend/sports/common/ui/shared';
import { DsButtonKind, DsButtonSize } from '@frontend/ui/button';
import { Store } from '@ngrx/store';
import { EpcotConfigService, EpcotModule } from 'packages/sports/web/app/src/common/epcot-config.service';
import { Observable } from 'rxjs';

import { PickOddsState } from '../../../../core/picks/pick-models';
import { EditBetActions } from '../../actions';
import { IEditMyBetState } from '../../state';

@Component({
    template: '',
    standalone: false,
})
export abstract class EditBetAddPicksContainerComponent implements OnInit {
    editMyBetState$: Observable<IEditMyBetState>;
    pickCount = 0;
    private lockedOrClosedPickCount = 0;
    readonly buttonThemeKind: ThemeOptions<DsButtonKind> = { 'mgm-4': 'primary', 'sports-interaction': 'primary' };
    readonly buttonThemeSize: ThemeOptions<DsButtonSize> = { 'mgm-4': 'large', 'sports-interaction': 'large' };
    private readonly destroyRef = inject(DestroyRef);

    protected constructor(
        public siteCore: Sitecore,
        private store: Store,
        private epcotConfigService: EpcotConfigService,
    ) {}

    ngOnInit(): void {
        this.editMyBetState$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((next) => {
            this.pickCount = next.addPicksState.pickList.length;
            if (this.epcotConfigService.isEnabled(EpcotModule.MyBetsBetSlip)) {
                this.lockedOrClosedPickCount = next.addPicksState.pickList.filter(
                    (pick) => pick.oddsState === PickOddsState.Locked || pick.oddsState === PickOddsState.Closed,
                ).length;
            }
        });
    }

    cancelAddSelection(state: IEditMyBetState): void {
        this.store.dispatch(EditBetActions.cancelAddSelectionMode({ payload: state.addPicksState.pickList }));
    }

    addToBet(state: IEditMyBetState): void {
        this.store.dispatch(EditBetActions.confirmAddSelectionMode({ payload: { picks: state.addPicksState.pickList } }));
    }

    pickContainerToggle(): void {
        if (this.pickCount > 0) {
            this.store.dispatch(EditBetActions.togglePicksContainer());
        }
    }

    hasPicks(): boolean {
        return this.pickCount > 0;
    }

    get lockedOrClosedPicksCount(): number {
        return this.lockedOrClosedPickCount;
    }

    getNewSelectionTitle(state: IEditMyBetState): string {
        return this.pickCount === 1 ? this.siteCore.betslip.editBet.newSelection : this.siteCore.betslip.editBet.newSelections;
    }

    get lockedOrClosedPicksInfo(): string {
        return formatString(this.siteCore.betslip.editBet.addedBetLocked, this.lockedOrClosedPicksCount.toString());
    }
}
